import { TujuAccountInformation } from '@almamedia-legal-insights/types';

export const hasSubscriptionAccess = (authInfo?: TujuAccountInformation) => {
  if (!authInfo) {
    return false;
  }

  return authInfo.ipRights || authInfo.almaIdRights;
};
